<template>
  <b-button
    @click="$emit('click', $event)"
    :class="['reset', { 'reset--adaptive': adaptive }]"
    title="Сбросить"
  ><i class="reset__icon"/></b-button>
</template>

<script>
  export default {
    name: "ButtonReset",
    props: {
      adaptive: {
        type: Boolean,
        default: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  .reset {
    font-size: 0.875rem;
    font-weight: bold;
    line-height: 1.5rem;

    &__icon {
      background-image: url("../assets/reload_white.svg");
      background-repeat: no-repeat;
      width: 1.5rem;
      height: 1.5rem;
      line-height: 1.5rem;
      display: inline-block;
      vertical-align: bottom;
      padding: 0.25rem 0 0;
      background-position: center;
      background-size: contain;
    }

    &--white {
      background-color: #ffffff;

      .reset__icon {
        background-image: url("../assets/reload.svg");
      }
    }

    &--adaptive {
      @media screen and (max-width: 40em) {
        background-color: #ffffff !important;
        border-color: #ffffff;
        color: #145aa0 !important;
        .reset__icon {
          background-image: url("../assets/reload.svg");
        }
      }
    }
  }
</style>
